module.exports = __webpack_public_path__ + "static/media/terminal.f6e8ecc8.svg";